import React from 'react';
import { Box } from '@mui/material';
import SectionHeader from './SectionHeader';
import UpcomingDeadlines from './UpcomingDeadlines';
import Notifications from './Notifications';
import ProjectProgress from './ProjectProgress';
import { t } from '../../../utils/textUtils';

const DeadlinesAndNotificationsSection = ({
  upcomingDeadlines,
  dashboardOverviewData,
  projects,
  notifications,
  activeProjects
}) => {
  return (
    <Box sx={{ mt: 4, mb: 2 }}>
      <SectionHeader
        title={t('JADWAL AKAN DATANG & PENGINGATAN')}
        subtitle={t('Pantau deadline penting dan pengingat terbaru.')}
      />
      
      {/* CSS Grid Layout untuk Deadlines & Notifications */}
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
          lg: 'repeat(3, 1fr)'
        },
        gap: 3,
        mb: 4
      }}>
        {/* Upcoming Deadline */}
        <UpcomingDeadlines 
          upcomingDeadlines={upcomingDeadlines}
          dashboardOverviewData={dashboardOverviewData}
          projects={projects}
        />
        
        {/* Notifications */}
        <Notifications notifications={notifications} />
        
        {/* PROJECT PROGRESS */}
        <ProjectProgress activeProjects={activeProjects} />
      </Box>
    </Box>
  );
};

export default DeadlinesAndNotificationsSection;
